import React, { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

interface UnlinkEmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  email?: string;
  isLoading?: boolean;
}

export const UnlinkEmailModal: React.FC<UnlinkEmailModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  email = '',
  isLoading = false,
}) => {
    const { t } = useTranslation('navigation');
  const cancelRef = useRef<HTMLButtonElement>(null);

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t('navigation:unlinkEmailAddress')}
                                </AlertDialogHeader>
          <AlertDialogCloseButton />

          <AlertDialogBody>
            {t('navigation:thisApplicationWillBeUnlinkedFro')} {email}{t('navigation:andTheUserAccountAssociatedWithT')}
                                </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose} isDisabled={isLoading}>
              {t('common:cancel')}
                                      </Button>
            <Button
              variant="solid"
              bgColor="red.500"
              onClick={handleConfirm}
              ml={3}
              isLoading={isLoading}
              loadingText={t('navigation:unlinking')}
            >
              {t('common:confirm')}
                                      </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
